import React from 'react';

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const ConfirmationModalTestReport = ({ props, setShowModal, showModal, onAccept, message }) => {

    const { className } = props;

    const onOk = () =>{
        setShowModal(false);
        onAccept();
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={onOk}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={() => setShowModal(false)}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">Actualizar Estatus</h4>
            </label>
        </div>
    );

    return (
        <BaseCustomModal
            title={title}
            isModalOpen={showModal}
            handleCancel={() => setShowModal(!showModal)}
            centered
            zIndex={9999}
            width="40%" 
            className={className}
            footer={buttons} 
        >
            <GradientDecorationLine />

            <div className="px-4">
                <label className="text-primary">{message}</label>
                <br />
            </div>

            <GradientDecorationLine />
        </BaseCustomModal>
    )

}
